module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter AboutTheAuthor",
    attrs: {
      "id": "section_abouttheauthor--num_1--seq_2"
    }
  }, [_c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_114616-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_c('b', [_vm._v("Helen Dickson")]), _vm._v(" was born and still lives in South Yorkshire, with her husband, on a busy arable farm, where she combines writing with keeping a chaotic farmhouse. An incurable romantic, she writes for pleasure, owing much of her inspiration to the beauty of the surrounding countryside. She enjoys reading and music. History has always captivated her, and she likes travel and visiting ancient buildings.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_114616-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_114616-00002"
    }
  }, [_c('b', [_vm._v("Recent novels by the same author:")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_114616-00002"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_114616-00003"
    }
  }, [_vm._v("THE PIRATE’S DAUGHTER "), _c('br'), _vm._v(" BELHAVEN BRIDE "), _c('br'), _vm._v(" THE EARL AND THE PICKPOCKET "), _c('br'), _vm._v(" HIS REBEL BRIDE "), _c('br'), _vm._v(" THE DEFIANT DEBUTANTE "), _c('br'), _vm._v(" ROGUE’S WIDOW, GENTLEMAN’S WIFE "), _c('br'), _vm._v(" TRAITOR OR TEMPTRESS "), _c('br'), _vm._v(" A SCOUNDREL OF CONSEQUENCE "), _c('br'), _vm._v(" WICKED PLEASURES  "), _c('br'), _vm._v("     ("), _c('i', [_vm._v("part of Christmas by Candlelight")]), _vm._v(") "), _c('br'), _vm._v(" FORBIDDEN LORD "), _c('br'), _vm._v(" SCANDALOUS SECRET, DEFIANT BRIDE "), _c('br'), _vm._v(" FROM GOVERNESS TO SOCIETY BRIDE")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a07114c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781408913727_abouttheauthor.vue
// module id = 60
// module chunks = 0